"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const config_1 = require("@completeanatomy/config");
const event_bus_1 = require("@completeanatomy/event-bus");
const http_1 = require("@completeanatomy/http");
const store_1 = require("@completeanatomy/store");
const lodash_isequal_1 = __importDefault(require("lodash.isequal"));
const redux_watch_1 = __importDefault(require("redux-watch"));
require("reflect-metadata");
const typedi_1 = require("typedi");
/**
 * This module authenticates users by bridge interface
 */
let Auth = class Auth {
    /**
     * Creates instance of Auth module
     *
     * @param bridge - bridge object to use in module
     * @param config - object with the app configuration
     * @param http - the HTTP module to make HTTP requests
     * @param store - object with the store to access to AppState
     * @param eventBus = authenticates users
     */
    constructor(bridge, config, http, eventBus, store) {
        this.bridge = bridge;
        this.config = config;
        this.http = http;
        this.eventBus = eventBus;
        this.store = store;
        /**
         * Subscribe to authWasCancelled changes in the state
         */
        const authWasCancelledFieldWatcher = (0, redux_watch_1.default)(this.store.getState, 'auth.authWasCanceled', lodash_isequal_1.default);
        this.store.subscribe(authWasCancelledFieldWatcher((newValue) => {
            if (newValue) {
                this.eventBus.emit(event_bus_1.AuthEvent.AuthWasCancelled);
                bridge.emit(bridge_schema_1.bridgeObjectChanged, {
                    identifier: 'auth',
                    keyPath: 'authWasCanceled',
                    changes: false,
                });
            }
        }));
        /**
         * Subscribe to access token changes in the state
         */
        const authFieldWatcher = (0, redux_watch_1.default)(this.store.getState, 'auth', lodash_isequal_1.default);
        this.store.subscribe(authFieldWatcher((newValue, oldValue) => {
            /**
             * If a user had an access token and now there isn't the access token remove it from the config and emit NeedClearUserData event
             */
            if ((!newValue || !(newValue === null || newValue === void 0 ? void 0 : newValue.accessToken)) &&
                oldValue &&
                oldValue.accessToken) {
                this.config.delete('accessToken');
                this.eventBus.emit(event_bus_1.AuthEvent.NeedClearUserData);
                return;
            }
            /**
             * Save new access token to the config if it was changed
             */
            if (newValue &&
                newValue.accessToken &&
                newValue.accessToken !== (oldValue === null || oldValue === void 0 ? void 0 : oldValue.accessToken)) {
                this.config.set('accessToken', newValue === null || newValue === void 0 ? void 0 : newValue.accessToken);
            }
            /**
             * Emit Authenticated event if a user was unauthenticated and there is a new access token
             */
            if ((!oldValue || !oldValue.accessToken) &&
                newValue &&
                newValue.accessToken) {
                this.eventBus.emit(event_bus_1.AuthEvent.Authenticated);
            }
            /**
             * If there was an old access token and a user has a new one emit AccessTokenWasRefreshed event
             */
            if (oldValue &&
                oldValue.accessToken &&
                newValue &&
                newValue.accessToken &&
                oldValue.accessToken !== newValue.accessToken) {
                this.eventBus.emit(event_bus_1.AuthEvent.AccessTokenWasRefreshed);
            }
            if (newValue === null || newValue === void 0 ? void 0 : newValue.needUpdate) {
                if (this.isAuthenticated()) {
                    this.eventBus.emit(event_bus_1.AuthEvent.NeedUpdateUserData);
                }
                bridge.emit(bridge_schema_1.bridgeObjectChanged, {
                    identifier: 'auth',
                    keyPath: 'needUpdate',
                    changes: false,
                });
            }
        }));
        const regionFieldWatcher = (0, redux_watch_1.default)(this.store.getState, 'deviceInformation.region', lodash_isequal_1.default);
        this.store.subscribe(regionFieldWatcher((newValue) => {
            this.bridge.emit(bridge_schema_1.bridgeObjectChanged, {
                identifier: 'auth',
                keyPath: 'browserFlow.authType',
                changes: newValue === bridge_schema_1.AppRegion.China ? 'sso' : 'neoId',
            });
        }));
        this.http.on(http_1.HTTPEvent.Error, this.handleHttpError, this);
    }
    /**
     * Ask native side to do authentication of a user
     */
    authenticate() {
        this.bridge.authenticate();
    }
    signUp() {
        this.bridge.signUp();
    }
    /**
     * Refresh user token
     */
    refresh() {
        this.bridge.refresh();
    }
    /**
     * Logout user from the app
     */
    logout() {
        this.bridge.logout();
    }
    /**
     * Ask native part to open OAuth interface to edit user account information
     */
    editAccount() {
        this.bridge.editAccount();
    }
    /**
     * Ask native part to open OAuth interface to change password
     */
    changePassword() {
        this.bridge.changePassword();
    }
    /**
     * Returns true if a user is authenticated and has access token in the config
     */
    isAuthenticated() {
        return this.config.has('accessToken');
    }
    /**
     * Returns identity token from the app state
     */
    get identityToken() {
        const { auth } = this.store.getState();
        return auth === null || auth === void 0 ? void 0 : auth.identityToken;
    }
    /**
     * Handler for HTTP module errors
     *
     * @param response - HTTP response with error
     *
     * @private
     */
    handleHttpError(response) {
        return __awaiter(this, void 0, void 0, function* () {
            switch (response.status) {
                case 401:
                    const data = yield response.clone().json();
                    /**
                     * Do authorization on 401 expired token error
                     */
                    if (data.detail === 'expired token') {
                        this.refresh();
                    }
                    break;
            }
        });
    }
};
exports.Auth = Auth;
/**
 * Name of exported module property
 */
Auth.exportName = 'auth';
exports.Auth = Auth = __decorate([
    (0, typedi_1.Service)(),
    __param(4, (0, typedi_1.Inject)(store_1.StoreToken)),
    __metadata("design:paramtypes", [bridge_schema_1.BridgeInterface,
        config_1.Config,
        http_1.HTTP,
        event_bus_1.EventBus, Object])
], Auth);
